import { baseApi } from './baseApi'

export const originHousesApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        /** 獲取祖先屋源詳細資料*/
        getOriginHousesDetail: builder.query({
            query: (originHouseId) => ({
                url: `lessor/v1/origin-houses/${originHouseId}`,
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
        }),
        // 創建祖先屋源或稱物件
        createOriginHousesDetail: builder.mutation({
            query: ({ images = [], property_manager_ids = [], ...data }) => {
                const formData = new FormData()

                Object.keys(data).map((key) => formData.append(key, data[key]))
                images.forEach((image) => {
                    formData.append('images', image)
                })
                property_manager_ids.forEach((property_manager_id) => {
                    formData.append('property_manager_ids', property_manager_id)
                })

                return {
                    url: `lessor/v1/origin-houses`,
                    method: 'POST',
                    data: formData,
                }
            },
        }),
        /** 更新物件基本資訊 */
        updateOriginHousesDetail: builder.mutation({
            query: ({ id: originHouseId, image, ...data }) => {
                const formData = new FormData()
                Object.keys(data).map((key) => formData.append(key, data[key]))
                image.forEach((image) => {
                    formData.append('images', image)
                })
                return {
                    url: `lessor/v1/origin-houses/${originHouseId}`,
                    method: 'PATCH',
                    data: formData,
                }
            },
        }),
        /** 取得物件客製化網站設定 */
        getOriginHousesPluginsCustomerWebsiteSetting: builder.query({
            query: (originHouseId) => ({
                url: `lessor/v1/origin-houses/${originHouseId}/plugins-customer-website/setting`,
                method: 'GET',
            }),
            providesTags: ['POST'],
        }),
        /** 同步物件客製化網站設定 */
        updateOriginHousesPluginsCustomerWebsiteSettingSync: builder.mutation({
            query: ({ id: originHouseId, ...data }) => ({
                url: `lessor/v1/origin-houses/${originHouseId}/plugins-customer-website/setting/sync`,
                method: 'PUT',
                data,
            }),
            invalidatesTags: ['POST'],
        }),
        /** 分享物件網頁連結 */
        getOriginHouseShareLink: builder.query({
            query: (originHouseId) => ({
                url: `lessor/v1/origin-houses/${originHouseId}/plugins-customer-website/share-link`,
                method: 'POST',
            }),
        }),
        /** 轉移物件至其他組織(需為同組織類型以及同擁有者-同法人，自然人需為同房東) */
        transferOriginHouseToOrganize: builder.mutation({
            query: ({ originHouseId, orgId }) => {
                return {
                    url: `lessor/v1/origin-houses/${originHouseId}/transfer-to-org`,
                    method: 'POST',
                    data: { org_id: orgId },
                }
            },
        }),
        // 獲取祖先屋源列表 - 待出租
        getOriginHousesWaitRentInfinity: builder.query({
            query: (query) => {
                return {
                    url: 'lessor/v1/origin-houses/wait-rent' + query,
                    method: 'GET',
                }
            },
            keepUnusedDataFor: 0,
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                // if skip or take is not provided, return the endpoint name
                if (typeof queryArgs === 'symbol') return endpointName

                const urlParams = new URLSearchParams(queryArgs)
                // if org_id changed then refetch
                const orgId = urlParams.get('org_id')
                const searchValue = urlParams.get('like_search_value')
                return endpointName + orgId + searchValue
            },
            merge: (currentCache, newItems) => {
                currentCache.origin_houses.push(...newItems.origin_houses)
                currentCache.skip = newItems.skip
                currentCache.take = newItems.take
                currentCache.total = newItems.total
            },
            forceRefetch({ currentArg, previousArg }) {
                return currentArg !== previousArg
            },
        }),

        // 獲取祖先屋源列表 - 出租中 /lessor/v1/origin-houses/renting
        getOriginHousesRentingInfinity: builder.query({
            query: (query) => {
                return {
                    url: 'lessor/v1/origin-houses/renting' + query,
                    method: 'GET',
                }
            },
            keepUnusedDataFor: 0,
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                // if skip or take is not provided, return the endpoint name
                if (typeof queryArgs === 'symbol') return endpointName

                const urlParams = new URLSearchParams(queryArgs)
                // if org_id changed then refetch
                const orgId = urlParams.get('org_id')
                const searchValue = urlParams.get('like_search_value')
                return endpointName + orgId + searchValue
            },
            merge: (currentCache, newItems) => {
                currentCache.origin_houses.push(...newItems.origin_houses)
                currentCache.skip = newItems.skip
                currentCache.take = newItems.take
                currentCache.total = newItems.total
            },
            forceRefetch({ currentArg, previousArg }) {
                return currentArg !== previousArg
            },
        }),
        // 獲取所有屬於此組織的支持的複製模板類型
        getSupportForCopyTemplateTypes: builder.query({
            query: (orgId) => ({
                url: `lessor/v1/organizations/${orgId}/support-for-copy-template-types`,
                method: 'GET',
            }),
        }),
        /* 獲取祖先屋源最新的合約範本Template */
        getOriginHousesNewstContractTemplate: builder.query({
            keepUnusedDataFor: 0,
            query: ({ originHouseId, houseId, type }) => {
                const searchParams = new URLSearchParams()
                if (houseId) {
                    searchParams.set('house_id', houseId)
                } else if (type) {
                    searchParams.set('type', type)
                }
                return {
                    url: `lessor/v1/origin-houses/${originHouseId}/newst-contract-template?${searchParams.toString()}`,
                    method: 'GET',
                }
            },
        }),
        /* 獲取屋源合約資料Template(get house contract teamplte) */
        getHouseContractTemplate: builder.query({
            keepUnusedDataFor: 0,
            query: (houseId) => ({
                url: `lessor/v1/houses/${houseId}/contract-template`,
                method: 'GET',
            }),
        }),
        // /lessor/v1/origin-houses/{origin_house_id}/sync-bind-org-tags 同步綁定組織標籤
        syncBindOrgTags: builder.mutation({
            query: ({ originHouseId, tagIds }) => {
                return {
                    url: `lessor/v1/origin-houses/${originHouseId}/sync-bind-org-tags`,
                    method: 'POST',
                    data: { sync_org_tag_ids: tagIds },
                }
            },
        }),
        // /lessor/v1/origin-houses/{origin_house_id} 刪除祖先屋源 - 只有當下沒有任一合約才能刪除
        deleteOriginHouse: builder.mutation({
            query: (originHouseId) => {
                return {
                    url: `lessor/v1/origin-houses/${originHouseId}`,
                    method: 'DELETE',
                }
            },
        }),
    }),
})

export const {
    useGetOriginHousesDetailQuery,
    useLazyGetOriginHousesDetailQuery,
    useCreateOriginHousesDetailMutation,
    useUpdateOriginHousesDetailMutation,
    useGetOriginHousesPluginsCustomerWebsiteSettingQuery,
    useUpdateOriginHousesPluginsCustomerWebsiteSettingSyncMutation,
    useLazyGetOriginHouseShareLinkQuery,
    useTransferOriginHouseToOrganizeMutation,
    useGetOriginHousesWaitRentInfinityQuery,
    useGetOriginHousesRentingInfinityQuery,
    useGetSupportForCopyTemplateTypesQuery,
    useLazyGetOriginHousesNewstContractTemplateQuery,
    useLazyGetHouseContractTemplateQuery,
    useSyncBindOrgTagsMutation,
    useDeleteOriginHouseMutation,
} = originHousesApi
